import { AdditionalRatesSlice, initialAdditionalRatesSlice } from './additional-rates/additional-rates.slice';
import {
    MarginCalculationsSlice,
    initialMarginCalculationsSlice
} from './margin-calculations/margin-calculations.slice';
import { MarginNotesSlice, initialMarginNotesSlice } from './margin-notes/margin-notes.slice';
import { MarginSetupSlice, initialMarginSetupSlice } from './margin-setup/margin-setup.slice';
import { MarginExpensesSlice, initialMarginExpensesSlice } from './margin-expenses/margin-expenses.slice';
import { CandidateDetailsSlice, initialCandidateDetailsSlice } from './candidate-details/candidate-details.slice';
import { JobDetailsSlice, initialJobDetailsSlice } from './job-details/job-details.slice';
import { initialMarginContractSlice, MarginContractSlice } from './margin-contract/margin-contract.slice';
import { MarginDetails } from '../models/margin-details.model';
import { initialMarginRtoDatesSlice, MarginRtoDatesSlice } from './margin-rto-dates/margin-rto-dates.slice';

export interface LocumsMarginCalculatorSlice {
    candidateDetails: CandidateDetailsSlice;
    jobDetails: JobDetailsSlice;
    marginSetup: MarginSetupSlice;
    additionalRates: Partial<AdditionalRatesSlice>;
    expenses: Partial<MarginExpensesSlice>;
    calculations: Partial<MarginCalculationsSlice>;
    notes: MarginNotesSlice;
    marginContract: MarginContractSlice;
    initialLoadingData?: MarginDetails;
    marginRtoDates: Partial<MarginRtoDatesSlice>;
}

export const initialLocumsMarginCalculatorSlice: LocumsMarginCalculatorSlice = {
    candidateDetails: initialCandidateDetailsSlice,
    jobDetails: initialJobDetailsSlice,
    marginSetup: initialMarginSetupSlice,
    additionalRates: initialAdditionalRatesSlice,
    expenses: initialMarginExpensesSlice,
    calculations: initialMarginCalculationsSlice,
    notes: initialMarginNotesSlice,
    marginContract: initialMarginContractSlice,
    initialLoadingData: undefined,
    marginRtoDates: initialMarginRtoDatesSlice
};
